import { PublicRow } from "./row"

/**
 * 外に見せる用のセル
 */
export class Cell {
	#grid
	#row
	#col
	constructor (grid, row, col) {
		this.#grid = grid
		this.#row = row
		this.#col = col
	}

	get value () {
		return this.#row.data[this.#col.id]
	}

	set value (val) {
		// 読み取り専用の場合は何もしない
		if (this.#col.readonly) return
		if (this.#grid.readonlyRowRule && this.#grid.readonlyRowRule(this.#row.data)) return

		this.#updateCore(val)
	}

	get valueIsReadonly () {
		return this.#row.data[this.#col.id]
	}

	set valueIsReadonly (val) {
		this.#updateCore(val)
	}

	forceUpdate (val) {
		this.#updateCore(val)
	}

	#updateCore (val) {
		this.#grid.modifyCell(this.#row, this.#col, val)
	}

	get isSelected () {
		if (!this.#grid.currentCellInfo) return false
		return this.#grid.currentCellInfo.rowId === this.#row.id && this.#grid.currentCellInfo.col.id === this.#col.id
	}

	get colType () {
		return this.#col.type
	}

	get colId () {
		return this.#col.id
	}

	get row () {
		return new PublicRow(this.#grid, this.#row)
	}
}
